import { render } from "./AllMessagesView.vue?vue&type=template&id=1772553d"
import script from "./AllMessagesView.vue?vue&type=script&lang=js"
export * from "./AllMessagesView.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/demo-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__